import { OpenaiKeySettings } from "app/features/openai/mod.ts";
import { Toolbar } from "app/features/toolbar/mod.ts";
import { Panel } from "local/ui/panel.tsx";
import { View } from "local/ui/view.tsx";

/** MAIN **/

export function Openai() {
  return (
    <View class="flex flex-1 relative">
      <View class="absolute w-full h-full">
        <Panel>
          <OpenaiKeySettings />
        </Panel>
        <Toolbar />
      </View>
    </View>
  );
}
